/**
 * The two measures this screen is built on.
 *
 * They are the same number and not the same idea, which is why they are both here: one is what a
 * card holds its contents off its own edge, the other is what a line of type on the ground holds
 * itself off the page's. They happen to agree, and that agreement is the point — a studio's name
 * and the week above it begin on one line.
 */

/** A card's inset, on every side. */
export const PAD = 16

/**
 * Where a line of type starts, for anything not inside a card.
 *
 * The cards sit at the page's own inset and fill it. Type set to the same measure reads as closer
 * to the glass than they do, because a card's edge is a straight run of colour and a letter's is
 * not. At a card's own padding, the week, the empty-state heading and a studio's name all begin
 * on the same line, and the only thing starting at the page's edge is a panel.
 */
export const TYPE_INSET = PAD

/** What a finger is entitled to, and what a pill is drawn at to leave room around it. */
export const TAP = 44
export const PILL = 40

/** Half the gap between neighbouring pills, so no target ever reaches the next one. */
export const SLOP = { top: 2, bottom: 2, left: 4, right: 4 }
